import ButtonDialog from 'components/button-dialog';
import { useEffect } from 'react';
import { SET_CROSS_DISTRIBUTOR_BINDING_DIALOG, useLicensePlateContext } from './use-license-plate';
import amplitude from 'service/amplitude';

const CrossDistributorBindingPlateDialog = () => {
  const { state, dispatch } = useLicensePlateContext();

  useEffect(() => {
    if (state.showCrossDistributorBindingPlateDialog) {
      amplitude.plateNumber_cross_dist_dialog_pageview();
    }
  }, [state.showCrossDistributorBindingPlateDialog]);

  return (
    <ButtonDialog
      title="車牌尚綁定在其他服務"
      items={[
        {
          content: '知道了',
          theme: 'positive',
          onClick: () => {
            amplitude.plateNumber_cross_dist_dialog_confirm_onClick();
            dispatch({ type: SET_CROSS_DISTRIBUTOR_BINDING_DIALOG, payload: false });
          },
        },
      ]}
      isShow={state.showCrossDistributorBindingPlateDialog}
    >
      提醒您，若欲完全取消扣款，請解除綁定其他車牌自動付款服務，以避免持續扣款。
    </ButtonDialog>
  );
};

export default CrossDistributorBindingPlateDialog;
